import { useAuth } from "@clerk/tanstack-react-start";
import React from "react";
import { Route as RootRoute } from "~/routes/__root";

export function SignedIn({ children }: { children: React.ReactNode }) {
	const { isLoaded, isSignedIn } = useAuth();
	const { navbarViewer } = RootRoute.useRouteContext();

	if (isLoaded && isSignedIn) return children;
	if (!isLoaded && navbarViewer) return children;
	return null;
}
